<template>
  <div>
    <v-card class="ma-4 word_keeper">
      <v-toolbar dense flat color="white">
        <v-toolbar-title class="font-weight-bold pa-0">
          <v-icon class="mr-2">mdi-square-edit-outline</v-icon>방문증 분실 신고
        </v-toolbar-title>
        <v-spacer></v-spacer>

      </v-toolbar>
      <v-divider class="mr-4 ml-4"></v-divider>
      <v-card outlined tile class="ma-4">
        <v-card-text class="pt-8 pb-0">
          <v-row class="mb-0">
            <v-col cols="12" sm="6" md="3">
              <v-text-field v-if="CustomInfo.Local == 'Y'" v-model="CustomInfo.CorpNmKor" label="소속 업체명" dense disabled persistent-placeholder></v-text-field>
              <v-text-field v-else v-model="CustomInfo.CorpNmEng" label="소속 업체명" dense disabled persistent-placeholder></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-text-field v-model="editedItem.cTel" label="휴대전화번호" dense disabled persistent-placeholder></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-text-field v-model="editedItem.cPassNm" label="방문증번호" dense disabled persistent-placeholder></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-text-field v-model="editedItem.cChargeUserNm" label="담당자 이름" dense disabled persistent-placeholder></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card outlined tile class="ma-4 essetial_card">
        <v-card-text class="pt-8 pb-0">
          <v-row class="mb-0">
            <v-col cols="12" sm="6" md="3">
              <IronDate v-model="editedItem.cLostDateTime" :bSelect="bSelect" :sMaxDate="sToday" @update="onDateRangeChange" ref="IronDateRef" cLabelEs="분실일자" style="width:100%;"/>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-text-field v-model="editedItem.cLostCustomNm" @keyup="ResetLostInfo()" @keyup.enter="ShowDialog()" @click:append-outer="ShowDialog()" append-outer-icon="search" class="essetial_input" dense persistent-placeholder>
                <template v-slot:label>
                  분실자명<strong class="red--text">*</strong>
                </template>
              </v-text-field>
              <!-- <v-text-field v-if="CustomInfo.Manager == 'M'" v-model="editedItem.cCustomNm" @keyup.enter="ShowDialog()" @click:append-outer="ShowDialog()" append-outer-icon="search" dense persistent-placeholder>
                <template v-slot:label>
                  분실자명<strong class="red--text">*</strong>
                </template>
              </v-text-field>
              <v-text-field v-else v-model="editedItem.cCustomNm" dense persistent-placeholder readonly>
                <template v-slot:label>
                  분실자명<strong class="red--text">*</strong>
                </template>
              </v-text-field> -->
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-select v-model="zSelecetedLostItem" :items="zLostItemInfo" :menu-props="{ bottom: true, offsetY: true,closeOnContentClick : bCheckMenuList }" multiple dense persistent-placeholder>
                <template v-slot:label>
                  분실물품<strong class="red--text">*</strong>
                </template>
                <template v-slot:selection="{ item }">
                  <v-chip small>
                    <span>{{ item.text }}</span>
                  </v-chip>
                </template>
                <template v-slot:prepend-item>
                  <v-list-item ripple @mousedown.prevent @click="toggle" :class="zSelecetedLostItem.length > 0 ? 'grey lighten-1' : ''">
                    <v-list-item-action>
                      <v-icon :color="zSelecetedLostItem.length > 0 ? 'black' : ''">
                        {{ cCheckBoxIcon }}
                      </v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>
                        전체 선택
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
                <template v-slot:item="{ item }">
                  <v-list-item ripple @mousedown.prevent @click="fPushItem(item)" :class="zSelecetedLostItem.includes(item) ? 'grey lighten-1' : ''">
                    <v-list-item-action>
                      <v-icon :class="zSelecetedLostItem.includes(item) ? 'mdi mdi-checkbox-marked' : 'mdi mdi-checkbox-blank-outline'" :color="zSelecetedLostItem.includes(item) ? 'black' : ''"></v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ item.text }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>                <template v-slot:append-item>
                  <v-divider class="mb-2"></v-divider>
                  <div align="right">
                    <v-btn @click="bCheckMenuList = true" class="mr-2" dark small><v-icon>mdi-check</v-icon>선택</v-btn>
                  </div>
                </template>
              </v-select>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>


      <v-card-text align="center">
        <v-divider class="mb-4"></v-divider>
        <v-btn @click="$router.push({name: 'MainBoard'});" text class="mr-2"><v-icon class="mr-2">dashboard</v-icon>홈</v-btn>
        <!-- <v-btn v-if="CustomInfo.Manager != 'M' || CustomInfo.Manager != 'S'" @click="SetPassLog('A')" dark class="ml-2"><v-icon class="mr-2">post_add</v-icon>신청</v-btn>
        <v-btn v-else @click="SetPassLog('R')" dark class="ml-2"><v-icon class="mr-2">post_add</v-icon>요청</v-btn> -->
        <v-btn @click="SetPassLog()" dark class="ml-2"><v-icon class="mr-2">post_add</v-icon>요청</v-btn>
      </v-card-text>
    </v-card>


    <ChargeDialog ref="ChargeDialogRef" @SetLostCustom="SetLostCustom"/>
  </div>
</template>

<script>
import BasicInfo from "../BasicInfo.js";
import axios from "axios";
import EventBus from "@/eventBus.js";
import { mapState } from "vuex";
import IronDate from '@/components/iron28Calendar/src/IronDate4.vue';
import Util from "../Util.js";

import ChargeDialog from "../components/ChargeDialog.vue";

export default {
  components: {
    IronDate,
    ChargeDialog,
  },
  data: () => ({
    bCheckMenuList : false,
    bSelect : true,
    sToday : new Date(),
    cNoMsg : "",
    editedItem : {
      cPassMappingId : "",
      cPassId : "",
      cLostCustomId  : "",
      cLostCustomNm  : "",
      cChargeCustomId  : "",
      cChargeCustomTel : "",
      cChargeCustomNm : "",
      cTel  : "",
      cPassNm  : "",
      cChargeUserNm  : "",
      cLostDateTime : Util.sFormatDate(Date()),
    },
    defaultItem : {
      cPassMappingId : "",
      cPassId : "",
      cLostCustomId  : "",
      cLostCustomNm  : "",
      cChargeCustomId  : "",
      cChargeCustomTel : "",
      cChargeCustomNm : "",
      cTel  : "",
      cPassNm  : "",
      cChargeUserNm  : "",
      cLostDateTime : Util.sFormatDate(Date()),
    },
    zSelecetedLostItem: [],
  }),
  computed: {
    ...mapState(["CustomInfo","zLostItemInfo"]),
    likesAllFruit () {
      return this.zSelecetedLostItem.length === this.zLostItemInfo.length
    },
    likesSomeFruit () {
      return this.zSelecetedLostItem.length > 0 && !this.likesAllFruit
    },
    cCheckBoxIcon () {
      if (this.likesAllFruit) return 'mdi-checkbox-marked'
      if (this.likesSomeFruit) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    cCheckSelectIcon () {
      if (this.likesAllFruit) return 'mdi-checkbox-marked'
      if (this.likesSomeFruit) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
  },

  created() {
  },

  mounted() {
    if (this.CustomInfo.Manager == "N") {
      this.GetLostCustomInfo();
    }
    var now = new Date();
    this.sToday = new Date(now.setMonth(now.getMonth() - 1));
  },

  methods : {
    fPushItem(item) {
      this.bCheckMenuList = false
      let iIndex = this.zSelecetedLostItem.indexOf(item)
      if (iIndex == -1) {
        this.zSelecetedLostItem.push(item)
      } else {
        this.zSelecetedLostItem.splice(iIndex,1)
      }
      this.zSelecetedLostItem.sort(function(a, b){
        return a.value - b.value
      })
    },

    toggle() {
      this.$nextTick(() => {
        this.bCheckMenuList = false
        if (this.likesAllFruit) {
          this.zSelecetedLostItem = []
        } else {
          this.bCheckMenuList = true
          this.zSelecetedLostItem = this.zLostItemInfo.slice()
        }
      })
    },
    
    ResetLostInfo(){
      this.editedItem.cPassNm = ""
      this.editedItem.cTel = ""
      this.editedItem.cPassId = ""
      this.editedItem.cPassMappingId = ""
      this.editedItem.cLostCustomId = ""
      this.editedItem.cChargeUserNm = ""
    },
    
    onDateRangeChange(daterange){
      this.editedItem.cLostDateTime = Util.sFormatDate(daterange.startDate);
    },

    ShowDialog(){
      this.$refs.ChargeDialogRef.ShowDialog(3,this.editedItem.cLostCustomNm);
    },

    SetLostCustom(item,oChargeCustom){
      this.editedItem.cChargeUserNm = item[0].cChargeUserNm
      this.editedItem.cPassMappingId = item[0].cPassMappingId
      this.editedItem.cPassNm = item[0].cPassNm
      this.editedItem.cTel = item[0].cTel
      this.editedItem.cCorpId = item[0].cCorpId
      this.editedItem.cPassId = item[0].cPassId
      this.editedItem.cLostCustomId = item[0].cCustomId
      this.editedItem.cLostCustomNm = item[0].cCustomNm

      this.editedItem.cChargeCustomTel = oChargeCustom.cChargeCustomTel
      this.editedItem.cChargeCustomNm = oChargeCustom.cChargeCustomNm
    },

    SetPassLog(){
      let cState = ""
      let cChargeCorpId = ""

      this.editedItem.cChargeCustomId = ""
      if (this.CustomInfo.Manager == 'M' || this.CustomInfo.Manager == 'S') {
        cState = "R"
        this.editedItem.cChargeCustomId = this.CustomInfo.CustomId
        this.editedItem.cChargeCustomNm = this.CustomInfo.CustomNm
        cChargeCorpId = this.CustomInfo.CorpId
      } else {
        cState = "A"
        this.editedItem.cChargeCustomId = ""
        cChargeCorpId = ""
      }

      if (this.editedItem.cLostCustomId == "") {
        EventBus.$emit("onShowMsgBox", "필수 입력 사항이 누락되었습니다.","분실자를 선택하여 주세요.");
        return
      }

      if (this.editedItem.cPassId == "" || this.editedItem.cPassId == undefined ) {
        EventBus.$emit("onShowMsgBox", "필수 입력 사항이 누락되었습니다.","방문증 번호를 입력하여 주세요.");
        return
      }

      if (this.zSelecetedLostItem.length == 0) {
        EventBus.$emit("onShowMsgBox", "필수 입력 사항이 누락되었습니다.","분실한 물품을 선택하여 주세요.");
        return
      }

      if (this.editedItem.cChargeCustomTel == "") {
        EventBus.$emit("onShowMsgBox", "해당 업체의 정 관리자가 존재하지 않습니다.","소속 업체에 문의 하여 정 관리자 등록을 먼저 하여 주세요.");
        return
      }

      var posData = {
        Idx : "",
        CustomId : this.CustomInfo.CustomId,
        CorpId : this.CustomInfo.CorpId,
        Manager : this.CustomInfo.Manager,
        PassId : this.editedItem.cPassId,
        PassMappingId : this.editedItem.cPassMappingId,
        LostCustomId : this.editedItem.cLostCustomId,
        LostCustomNm : this.editedItem.cLostCustomNm,
        LostDateTime : this.editedItem.cLostDateTime,
        ChargeCustomId : this.editedItem.cChargeCustomId,
        ChargeCustomTel : this.editedItem.cChargeCustomTel,
        ChargeCustomNm : this.editedItem.cChargeCustomNm,
        ChargeCorpId : cChargeCorpId,
        State : cState,
        LostItem : this.zSelecetedLostItem,
      };

      axios
        .post(BasicInfo.UIL_API + "SetPassLog", posData, {
          headers: {
           "Authorization": this.CustomInfo.Token
          }
        })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          if (res.data.ResultCd == "66") { EventBus.$emit("onChangeCorpInfo"); return; }
          if (res.data.ResultCd === "00") {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.zSelecetedLostItem = [];

            EventBus.$emit("onShowMsg",false,  "방문증 분실 신고 신청이 완료되었습니다.");
          } else if (res.data.ResultCd === "02") {
            EventBus.$emit("onShowMsgBox","관리자 권한이 변경 되었습니다.",  "화면을 다시 접속하여 주세요.");
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);        
        });
    },

    GetLostCustomInfo(){
      var posData = {
        CorpId : this.CustomInfo.CorpId,
        CustomId : this.CustomInfo.CustomId,
        Manager : this.CustomInfo.Manager,
        NowSearchKeyWord : this.cNowSearchkeyWord,
      };

      axios
        .post(BasicInfo.UIL_API + "GetLostCustomInfo", posData, {
          headers: {
           "Authorization": this.CustomInfo.Token
          }
        })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          if (res.data.ResultCd === "00") {
            if (res.data.Result2[0].cTel == "") {
              EventBus.$emit("onShowMsgBox", "소속업체의 정 관리자 정보가 없습니다.",  "소속업체에 문의하여 정 관리자 등록은 먼저 진행하여 주세요.");  
              return
            }

            if (res.data.Result1.length > 0) {
              // let oChargeCustomInfo = {
              //   cTel : "",
              // }
              // oChargeCustomInfo.cTel = res.data.Result2[0].cChargeCustomTel
              this.SetLostCustom(res.data.Result1,res.data.Result2[0])
            }
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);        
        });
    },
  }
}
</script>

<style scoped>
</style>